import React from 'react';
import './ReminderToast.css';

function ReminderToast({ toasts, dismissToast, markDone, snooze }) {
  if (!toasts || toasts.length === 0) return null;

  return (
    <div className="rt-container">
      {toasts.map((inq) => (
        <div key={inq.id} className="rt-toast">
          <div className="rt-toast__icon">⏰</div>
          <div className="rt-toast__body">
            <div className="rt-toast__title">Follow-up due — {inq.name}</div>
            {inq.follow_up_note && <div className="rt-toast__note">{inq.follow_up_note}</div>}
            <div className="rt-toast__actions">
              <a href={`/admin/inquiries?open=${inq.id}`} className="rt-btn rt-btn--primary">View</a>
              <a href={`tel:${inq.phone}`} className="rt-btn">Call</a>
              <button className="rt-btn" onClick={() => snooze(inq.id, 60)}>Snooze 1h</button>
              <button className="rt-btn rt-btn--done" onClick={() => markDone(inq.id)}>Done</button>
            </div>
          </div>
          <button className="rt-toast__close" onClick={() => dismissToast(inq.id)}>✕</button>
        </div>
      ))}
    </div>
  );
}

export default ReminderToast;